import React from 'react';

interface SelectedChipsProps {
  ids: string[];
  getLabel: (id: string) => string;
  onRemove: (id: string) => void;
  scrollable?: boolean;
}

const SelectedChips: React.FC<SelectedChipsProps> = ({
  ids,
  getLabel,
  onRemove,
  scrollable = false
}) => {
  const Container = ({ children }: { children: React.ReactNode }) => (
    scrollable
      ? <div className="max-h-40 overflow-y-auto px-4 pb-4">{children}</div>
      : <div className="p-4">{children}</div>
  );

  return (
    <Container>
      <div className="flex flex-wrap gap-2">
        {ids.map((id) => (
          <span
            key={id}
            className="inline-flex items-center gap-2 rounded-full bg-blue-100 dark:bg-blue-900/40 px-3 py-1 text-xs font-medium text-blue-700 dark:text-blue-200"
          >
            {getLabel(id)}
            <button
              type="button"
              onClick={() => onRemove(id)}
              className="ml-1 text-blue-500 hover:text-blue-700 dark:text-blue-200 dark:hover:text-white"
              aria-label={`Remove ${getLabel(id)}`}
            >
              ×
            </button>
          </span>
        ))}
      </div>
    </Container>
  );
};

export default SelectedChips;